import React from 'react';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleStar } from '@fortawesome/sharp-solid-svg-icons';

import { TetheredModal } from 'src/explore/elements/TetheredModal';

import styles from './index.module.sass';

interface StarShipperProps {
  className?: {
    modal?: string;
    tether?: string;
  };
}

export const StarShipper = ({ className }: StarShipperProps ) => (
  <TetheredModal
    className={cls( 'spec__star-shipper', className?.tether )}
    tether={
      <span className={`${styles.tether}`}>
        <FontAwesomeIcon className={`${styles.icon} mr-1`} icon={faCircleStar} />
        <span>Star Shipper</span>
      </span>
    }
  >
    <div className={cls( styles.modal, 'font-weight-normal ff-cabin', className?.modal )}>
      <p>
        <strong>Star Shippers</strong> have an outstanding track record of providing a great
        Goldbelly experience&mdash;they consistently earn the highest ratings, and have shipped
        10,000+ orders on time.
      </p>
    </div>
  </TetheredModal>
);
